import * as React from "react";
const SvgFiRrBoxingGlove = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#062147"
      d="M20 7.126V7a7.01 7.01 0 0 0-7-7H8a7.01 7.01 0 0 0-7 7v6.868a7.96 7.96 0 0 0 1.45 4.593l.55.785V20a4 4 0 0 0 4 4h9a4 4 0 0 0 4-4v-.641l.513-.487A8.03 8.03 0 0 0 23 13.075V11a4.01 4.01 0 0 0-3-3.874M16 22H7a2 2 0 0 1-2-2h13a2 2 0 0 1-2 2m5-8.925a6.03 6.03 0 0 1-1.866 4.348l-.607.577H4.569l-.482-.687A5.98 5.98 0 0 1 3 13.868v-3.405A4 4 0 0 0 5 11h7a1 1 0 0 0 0-2H5a2 2 0 0 1-2-2 5.006 5.006 0 0 1 5-5h5a5.006 5.006 0 0 1 5 5v.126A4.01 4.01 0 0 0 15 11v3a1 1 0 0 0 2 0v-3a2 2 0 1 1 4 0z"
    />
  </svg>
);
export default SvgFiRrBoxingGlove;
